import { Box, Center, Text } from '#core/components';

export const ErrorPage = () => {
  return (
    <Center h="50vh" mx="20%">
      <Box>
        <Text fontSize="1.5rem" fontWeight="bold">
          Oops. Something went wrong.
        </Text>
        <Text>
          We're sorry for the inconvenience. We have been notified and are
          looking into it. Please try again later.
        </Text>
      </Box>
    </Center>
  );
};
